import { useState } from "react";

import { useAdminApiQueryWithParams } from "../../../hooks";
import {
  IPayoutsSummary,
  IPayoutOverview,
} from "../../../interfaces-and-types";
import { TSummaryPeriod } from "../../../constants";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

import { View } from "./View";

export interface IPayoutsSummaryViewProps extends ISummarySectionViewProps<IPayoutOverview> {}

export const PayoutsSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingPayoutsSummary,
    // isSuccess: isSuccessPayoutsSummary,
    // isError: isErrorPayoutsSummary,
    data: payoutsSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{ currency: string }, IPayoutsSummary>(
    [
      "getPayoutsSummary",
      {
        currency: activeCurrency!,
      },
    ],
    {
      enabled: !!activeCurrency,
    },
  );

  const {
    isLoading: isLoadingPayoutsOverviewByPeriod,
    // isSuccess: isSuccessPayoutsOverviewByPeriod,
    // isError: isErrorPayoutsOverviewByPeriod,
    data: payoutsOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { currency: string; startDate: string; endDate: string },
    IPayoutOverview
  >(
    [
      "getPayoutsOverviewByPeriod",
      {
        currency: activeCurrency!,
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!activeCurrency &&
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? payoutsSummary?.today
      : summaryPeriod === "past week"
        ? payoutsSummary?.past_week
        : summaryPeriod === "past month"
          ? payoutsSummary?.past_month
          : summaryPeriod === "custom"
            ? payoutsOverviewByPeriod
            : payoutsSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingPayoutsOverviewByPeriod
      : isLoadingPayoutsSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
